module.exports = __webpack_public_path__ + "static/media/one-core-step-component.a2240a9d.mp4";